import { Outlet, Navigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

const PrivateCustomer = () => {
    const [checking, setChecking] = useState(true);
    const [isCustomer, setIsCustomer] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("user");

        if (!token) {
            setChecking(false);
            setIsCustomer(false);
            return;
        }

        axios.interceptors.request.use((config) => {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        });

        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                const profile = res?.data?.data || {};
                setIsCustomer(Boolean(profile.isCustomer));
                if (profile.isCustomer) {
                    localStorage.setItem("profile", JSON.stringify(profile));
                }
            })
            .catch(() => {
                localStorage.removeItem("user");
                localStorage.removeItem("profile");
                localStorage.removeItem("data");
                setIsCustomer(false);
            })
            .finally(() => {
                setChecking(false);
            });
    }, []);

    if (checking) {
        return <div />;
    }

    return isCustomer ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateCustomer;
